import { useEffect } from 'react';
import { initPendo } from '@locus-taxy/encore-observability/pendo';
import { createPendoData } from '../utils/pendoUtil';
import { PENDO_API_KEY } from '../config';
import { useUserId } from './useUser';

export const useAnalytics = ({ clientId }: { clientId: string }) => {
  const userId = useUserId();

  useEffect(() => {
    // No key (the document omits observability.pendoApiKey) means Pendo is
    // off for this stack — do not call the agent loader at all.
    if (!clientId || !userId || !PENDO_API_KEY) {
      return;
    }

    const { visitorData, accountData } = createPendoData({
      clientId,
      personnelId: userId,
    });
    const apiKey = PENDO_API_KEY;

    initPendo({ apiKey, visitor: visitorData, account: accountData });
  }, [clientId, userId]);
};
